// Utilización por Placa — un renglón por auto activo, con días disponibles /
// rentados / en servicio / libres, % utilización y % disponibilidad, y venta
// (prorateada al precio diario).
import supabase from "../../../supabase-client";

const fmtMoney = (v) => "$" + Math.round(Number(v) || 0).toLocaleString("es-MX");
const fmtPct = (v) => `${(Number(v) * 100).toFixed(1)}%`;
const fmtDays = (v) => Math.round(Number(v) || 0);

export const utilizationPerCarReport = {
  id: "utilization-per-car",
  title: "Utilización por Placa",
  description: "Detalle por auto: días disponibles, rentados, en servicio, libres, % utilización y venta en el periodo.",
  category: "Operaciones",
  filters: [
    { type: "daterange", fromKey: "from", toKey: "to", label: "Periodo", required: true },
  ],
  summary: [
    { type: "count", label: "Autos" },
    { type: "sum", label: "Venta Total", valueKey: "venta", valueFormat: fmtMoney },
  ],
  columns: [
    { key: "plate", label: "Placa" },
    { key: "model", label: "Modelo", width: 220, truncate: true },
    { key: "subarrendado", label: "Subarrendado" },
    { key: "branch", label: "Sucursal" },
    { key: "disponible", label: "Disp.", format: fmtDays, exportType: "integer" },
    { key: "rentado", label: "Rentado", format: fmtDays, exportType: "integer" },
    { key: "en_servicio", label: "Servicio", format: fmtDays, exportType: "integer" },
    { key: "libres", label: "Libres", format: fmtDays, exportType: "integer" },
    { key: "utilizacion", label: "Util.", format: fmtPct, exportType: "percent" },
    { key: "disponibilidad", label: "Disp. %", format: fmtPct, exportType: "percent" },
    { key: "venta", label: "Venta", format: fmtMoney, exportType: "currency" },
  ],
  async fetch({ from, to }) {
    if (!from || !to) throw new Error("Seleccionar periodo");
    const { data, error } = await supabase.rpc("report_utilization_per_car", {
      p_from: from, p_to: to,
    });
    if (error) throw error;
    return data || [];
  },
};
